import axios from '../http'


function get() {
    return axios.get('/sys/config/get');
}

function update(data) {
    return axios.post('/sys/config/update', data);
}

function getBrochure() {
    return axios.get('/sys/config/getBrochure');
}


export default {
    get,
    update,
    getBrochure
}